import statuses from '@/helpers/statuses'

const initialState = () => ({
  priorities: {},
  meta: {
    loading: {}
  }
})

export default api => ({
  state: initialState,

  getters: {
    priorities: state => userId => state.priorities[userId],
    prioritiesMe: (state, getters) => state.priorities[getters.profileMe.id],

    loadingPrioritiesMe: (state, getters) => state.meta.loading[getters.profileMe.id] || statuses.IDLE,
    loadingPriorities: state => userId => state.meta.loading[userId] || statuses.IDLE
  },

  mutations: {
    fetchPriorities: (state, userId) => {
      state.meta.loading = { ...state.meta.loading, [userId]: statuses.LOADING }
    },

    fetchPrioritiesSuccess: (state, { userId, priorities }) => {
      state.meta.loading = { ...state.meta.loading, [userId]: statuses.LOADED }
      state.priorities = { ...state.priorities, [userId]: priorities }
    },

    fetchPrioritiesFailure: (state, { userId, error }) => {
      state.meta.loading = { ...state.meta.loading, [userId]: statuses.FAILED }
    },

    updatePriority: (state, { userId, priority }) => {
      const priorities = [...state.priorities[userId]]
      const index = priorities.findIndex(p => p.id === priority.id)
      if (index !== -1) {
        priorities[index] = priority
      } else {
        priorities.push(priority)
      }
      state.priorities = { ...state.priorities, [userId]: priorities }
    },

    togglePriority: (state, { userId, priorityId }) => {
      const priorities = [...state.priorities[userId]]
      const priority = priorities.find(p => p.id === priorityId)
      if (priority) {
        priority.isDone = !priority.isDone
      }
      state.priorities = { ...state.priorities, [userId]: priorities }
    },

    deletePriority: (state, { userId, priorityId }) => {
      const priorities = [...state.priorities[userId]]
      const index = priorities.findIndex(p => p.id === priorityId)
      if (index !== -1) {
        state.meta = { ...state.meta, deleting: { index, priority: priorities[index], userId } }
        state.priorities = { ...state.priorities, [userId]: priorities.filter(p => p.id !== priorityId) }
      }
    },

    deletePrioritySuccess: state => {
      const { deleting, ...other } = state.meta
      state.meta = other
    },

    deletePriorityFailure: state => {
      if (state.meta.deleting) {
        const { index, priority, userId } = state.meta.deleting
        const priorities = [...state.priorities[userId]]
        priorities.insert(index, priority)
        state.priorities = { ...state.priorities, [userId]: priorities }
      }
    },

    resetPriorities: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchPrioritiesMe: async ({ commit, getters }) => {
      const { id } = getters.profileMe
      commit('fetchPriorities', id)
      try {
        const priorities = await api.fetchPrioritiesMe()
        commit('fetchPrioritiesSuccess', { userId: id, priorities })
      } catch (error) {
        commit('fetchPrioritiesFailure', { userId: id, error })
      }
    },

    fetchPriorities: async ({ commit }, userId) => {
      commit('fetchPriorities', userId)
      try {
        const priorities = await api.fetchPriorities(userId)
        commit('fetchPrioritiesSuccess', { userId, priorities })
      } catch (error) {
        commit('fetchPrioritiesFailure', { userId, error })
      }
    },

    addPriority: async ({ commit, getters }, data) => {
      const priority = await api.addPriority(data)
      const { id } = getters.profileMe
      commit('updatePriority', { userId: id, priority })
    },

    updatePriority: async ({ commit, getters }, payload) => {
      const priority = await api.updatePriority(payload.id, payload.data)
      const { id } = getters.profileMe
      commit('updatePriority', { userId: id, priority })
    },

    deletePriority: async ({ commit, getters }, priorityId) => {
      const { id } = getters.profileMe
      commit('deletePriority', { userId: id, priorityId })
      try {
        await api.deletePriority(priorityId)
        commit('deletePrioritySuccess')
      } catch {
        commit('deletePriorityFailure')
      }
    },

    togglePriority: async ({ commit, getters }, priorityId) => {
      const { id } = getters.profileMe
      commit('togglePriority', { userId: id, priorityId })
      const priority = await api.toggleDonePriority(priorityId)
      commit('updatePriority', { userId: id, priority })
    },

    clear: ({ commit }) => {
      commit('resetPriorities')
    }
  }
})
